import { createSlice } from "@reduxjs/toolkit";
import { ComponentType } from "../models/ComponentType";

const ComponentTypesInitialState: {
	componentTypes: ComponentType[];
} = {
	componentTypes: [],
};

export const ComponentTypesReducer = createSlice({
	name: "__",
	initialState: ComponentTypesInitialState,
	reducers: {
		setComponentTypes(state, { payload }) {
			state.componentTypes = payload;
		},
	},
});
